{
    "ChannelCode": "编号",
    "Components": {
        "MeetingEnd": {
            "FeedbackConfirmation": {
                "ExploreMoreFeatures": "探索更多功能",
                "ThanksMessage": "感谢您的参与，",
                "WorkingMessage": "希望翻译为您带来更好的活动体验。"
            },
            "FeedbackForm": {
                "FeedbackQuestion": "翻译质量如何？",
                "SessionClosedMessage": "即时翻译现已结束。",
                "ThankYouMessage": "希望这次服务对您有所帮助！"
            }
        }
    },
    "Continue": "继续",
    "Control": {
        "Original": "原文",
        "Spacing": "段距",
        "TextSize": "字级",
        "Tts": "TTS"
    },
    "Download": "下载",
    "Idle": "闲置",
    "Join": "加入",
    "LanguageSettings": "语言",
    "Live": "进行中",
    "Loading": {
        "Entering": "正在进入频道",
        "Joining": "正在加入频道"
    },
    "OK": "确定",
    "Pages": {
        "Home": {
            "EnterEventCodeMessage": "请输入频道代码。",
            "InputPlaceholder": "输入频道代码",
            "Title": "在场，就能听懂一切"
        },
        "SelectLanguage": {
            "SearchEmpty": "未找到匹配的语言",
            "SearchPlaceholder": "搜索语言",
            "Title": "选择翻译语言"
        }
    },
    "Pane": {
        "CatchUp": "跳到最新",
        "Source": "原文",
        "Translation": "译文",
        "Tts": "语音朗读",
        "TtsShort": "TTS"
    },
    "Share": "分享",
    "SpeechSpeed": "语速",
    "Start": "开始",
    "Submit": "提交",
    "Tips": {
        "Error": {
            "Channel": {
                "LimitExceeded": "频道已达同时连接上限，无法进入。"
            }
        },
        "Icon": {
            "ScrollToBottom": "回到最新",
            "ShareLink": "分享链接",
            "SpeechRate": "设置播放速度"
        }
    },
    "Toast": {
        "LanguageChanged": "翻译语言已切换为 {lang}",
        "LinkCopied": "链接已复制",
        "SourceOff": "已隐藏原文",
        "SourceOn": "已显示原文",
        "TtsOff": "语音朗读已关闭",
        "TtsOn": "语音朗读已开启"
    },
    "Transcript": {
        "Start": "以上没有更多内容"
    },
    "tutorialPage": {
        "downloadOverlay": {
            "originText": "原始文本",
            "summary": "摘要",
            "transcript": "文字稿"
        },
        "translationLanguage": {
            "title": "翻译语言"
        }
    }
}
